(function () {
  "use strict";
  var api = window.InShapeUnboxingReward;
  var config = document.querySelector("[data-ish-unboxing-config]");
  if (!api || !config || config.dataset.suppressShared === "true") return;
  try { if (window.sessionStorage.getItem("inshape-active-reward-journey-v1") === "unique") return; } catch (_) {}
  var state = null;
  var lastCart = null;
  var unavailable = false;
  var timer = null;
  var refreshing = false;
  var refreshAgain = false;
  var widgetRoot = null;
  var widgetObserver = null;
  var lastApplied = false;

  function carryPackLinks(surface) {
    surface.querySelectorAll("a[href]").forEach(function (link) {
      try {
        var url = new URL(link.getAttribute("href"), window.location.origin);
        if (url.origin !== window.location.origin || ["/products/3-pack-inshape-beaters-size-up", "/products/5-pack-inshape-compression-tanks-1"].indexOf(url.pathname) === -1) return;
        url.searchParams.set("view", "first-purchase-reward");
        url.searchParams.set("reward_kind", "shared");
        var source = state && state.tracking && state.tracking.entrySource;
        if (["hang_tag", "direct", "invitation_email", "receipt_email", "recovery_email"].indexOf(source) !== -1) url.searchParams.set("entry_source", source);
        var theme = window.Shopify && window.Shopify.theme;
        if (theme && (theme.role === "development" || theme.role === "unpublished")) url.searchParams.set("preview_theme_id", String(theme.id));
        var href = url.pathname + url.search + url.hash;
        if (link.getAttribute("href") !== href) link.setAttribute("href", href);
      } catch (_) {}
    });
  }

  function render() {
    if (!state || !state.valid) return;
    var applied = !unavailable && api.checkCart(lastCart, state);
    carryPackLinks(document);
    document.querySelectorAll("[data-ish-unboxing-cart-reward]").forEach(function (node) { node.remove(); });
    var widget = document.querySelector("upnova-widget#upezCart");
    var root = widget && widget.shadowRoot;
    if (root) {
      carryPackLinks(root);
      root.querySelectorAll("[data-ish-unboxing-cart-reward]").forEach(function (node) { node.remove(); });
      widget.toggleAttribute("data-ish-unboxing-discount", Boolean(state.valid));
      var style = root.querySelector("#ish-unboxing-cart-style");
      if (!style) {
        style = document.createElement("style"); style.id = "ish-unboxing-cart-style";
        style.textContent = ":host([data-ish-unboxing-discount]) .upez__shop_progress_pristine{display:none!important}";
        root.appendChild(style);
      }
      if (root !== widgetRoot) {
        root.addEventListener("click", function (event) {
          if (api.checkoutControl(event)) api.track("unboxing_checkout_started", { page_type: "upnova_cart" }, state);
        }, true);
        if (widgetObserver) widgetObserver.disconnect();
        widgetRoot = root;
        widgetObserver = new MutationObserver(function (records) {
          var external = records.some(function (record) {
            var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            return target && !target.closest("#ish-unboxing-cart-style");
          });
          if (external) schedule();
        });
        widgetObserver.observe(root, { childList: true, subtree: true, characterData: true });
      }
    }
    window.dispatchEvent(new CustomEvent("inshape:unboxing-cart-state", { detail: { applied: applied } }));
    if (applied && !lastApplied) api.track("unboxing_discount_confirmed", { page_type: "cart" }, state);
    lastApplied = applied;
  }

  function refresh() {
    if (refreshing) { refreshAgain = true; return; }
    refreshing = true;
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url || "/cart") + ".js";
    fetch(cartUrl, { credentials: "same-origin", headers: { Accept: "application/json" }, cache: "no-store" }).then(function (response) {
      if (!response.ok) throw new Error("cart_unavailable");
      return response.json();
    }).then(function (cart) { lastCart = cart; unavailable = false; render(); }).catch(function () { unavailable = true; render(); }).finally(function () {
      refreshing = false;
      if (refreshAgain) { refreshAgain = false; schedule(); }
    });
  }
  function schedule() {
    if (timer !== null) return;
    timer = window.setTimeout(function () { timer = null; refresh(); }, 180);
  }
  function initialize(resolved) {
    if (state || !resolved || !resolved.valid) return;
    state = resolved;
    api.applyState(state);
    refresh();
    ["cart:refresh", "cart:updated", "cart:item-added", "cart-drawer:open", "line-item:change:end"].forEach(function (name) { document.addEventListener(name, schedule); });
    document.addEventListener("click", function (event) {
      if (api.checkoutControl(event)) api.track("unboxing_checkout_started", { page_type: "cart" }, state);
      if (event.target.closest("#cart-drawer-toggle, [name='add'], .cart-update, [data-index], upnova-widget")) {
        schedule(); window.setTimeout(schedule, 900); window.setTimeout(schedule, 2000);
      }
    });
    window.addEventListener("pageshow", schedule);
    window.addEventListener("focus", schedule);
    var attempts = 0;
    var interval = window.setInterval(function () { attempts++; render(); if (widgetRoot || attempts >= 30) window.clearInterval(interval); }, 500);
  }
  window.addEventListener("inshape:unboxing-reward-state", function (event) { initialize(event.detail); });
  api.resolve({ allowPreview: true }).then(initialize);
})();
